<template>
    <div class="w-full mb-[16px]">
        <CustomTable :data="presences" :columnsCustom="columnn" :load="table_load">
            <template #other-filter>
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-x-[8px]">
                        <button v-on:click="getData('refresh')" :disabled="table_load" class="size-[35px] border rounded-xl flex items-center justify-center">
                            <RefreshCw color="#2b2b2b" :size="16" strokeWidth="1.3" :class="{'animate-spin':actu_load}"/>
                        </button>

                        <button :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':period_filter == 'm'}]" @click="period_filtering('m')">
                            <FlagTriangleLeft :size="16" strokeWidth="1.3"/>
                            Ce mois
                        </button>
                        <div class="inline-block relative">
                            <button @click="show_advanced = !show_advanced" :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':show_advanced}]">
                                <SlidersHorizontal color="#2b2b2b" :size="16" strokeWidth="1.3"/>
                                Filtres
                            </button>
                            <Transition @before-enter="beforeEnterBox" @enter="enterBox" @leave="leaveBox">
                                <div v-if="show_advanced" id="advanced-filter" class="flex items-center gap-x-[12px] text-black font-light rounded-3xl p-6 shadow bg-white border absolute top-[120%] left-1/2 z-10">
                                    <div class="flex items-center gap-x-[8px]">
                                        <label for="start" class="font-light">Début:</label>
                                        <input type="date" v-model="period.start" name="start" class="h-[35px] w-[130px] cursor-pointer p-3 rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                    </div>
                                    <div class="flex items-center gap-x-[8px]">
                                        <label for="end" class="font-light">Fin:</label>
                                        <input type="date" v-model="period.end" name="end" class="h-[35px] p-3 w-[130px] cursor-pointer rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                    </div>
                                    <button v-on:click="period_filtering('p')" :disabled="table_load || actu_load" class="h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light">
                                        Actualiser
                                    </button>
                                    <button @click="show_advanced = !show_advanced" class="size-[25px] rounded-full border flex items-center justify-center">
                                        <X :size="16" strokeWidth="1.3"/>
                                    </button>
                                </div>
                            </Transition>
                        </div>
                    </div>
                    <button class="bg-[#3c41e9] font-light gap-x-[8px] rounded-xl text-white px-4 h-[35px] flex items-center justify-center">
                            <FolderUp :size="16"/>
                            Exporter
                    </button>
                </div>
            </template>
            <template #row-cell="slotProps">
                <span v-if="slotProps.cellNumber == 0">
                    {{ formatDate(slotProps.value) }}
                </span>
                <span v-else-if="slotProps.cellNumber == 1">
                    <div class="flex items-center gap-x-[6px]">
                        <div class="size-[30px] rounded-full flex items-center justify-center bg-[#3474f4] text-white font-semibold">{{ slotProps.value.split('/')[0].trim()[0] }}</div>
                        <div class="flex flex-col items-start">
                            <span class="text-[12px]">{{ slotProps.value.split('/')[0] + " " + slotProps.value.split('/')[1] }}</span>
                            <!-- <span class="underline font-extralight text-[11px]">{{ slotProps.value.split('/')[2] }}</span> -->
                        </div>
                    </div>
                </span>
                <span v-else>
                    {{ slotProps.value }}
                </span>
            </template>
        </CustomTable>
    </div>
</template>

<script>
import API from '@/service/API';
import Swal from 'sweetalert2'
import { initdatable } from '@/js/functions.js'
import CustomTable from './Custom-table.vue';
import {createColumnHelper} from "@tanstack/vue-table";
import { convertirDateEnFrancais } from '@/utils/date-format';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import {RefreshCw,FlagTriangleLeft,X,FolderUp} from "lucide-vue-next";
import gsap from "gsap";

DataTable.use(DataTablesCore);
const columnHelper = createColumnHelper();
const columnsPresence = [
  columnHelper.accessor(row => row.created_at.split('T')[0], {
    id: 'arrive',
    header: "Date d'arrivé",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.user.first_name}/${row.user.last_name}`, {
    id: 'employe',
    header: "Employés",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.hour_start, {
    id: 'start_date',
    header: "Heure d'arrivé",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.hour_end, {
    id: 'end_date',
    header: "Date de départ",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.zone.label, {
    id: 'zone',
    header: "Site",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.work_time, {
    id: 'time_work',
    header: "Templs de travail",
    cell: info => info.getValue(),
  }),
]

export default {
    name: 'PresenceTableComponent',
    components: {
        CustomTable,
        RefreshCw,
        FlagTriangleLeft,
        X,FolderUp
    },
    data() {
        return {
            table_load: false,
            actu_load: false,
            period_filter: 'm',
            show_advanced: false,
            columnn: columnsPresence,
            period: {},
            presences: [],
        }
    },
    computed: {
        comp1() {
            return ""
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        formatDate(date){
            return convertirDateEnFrancais(date);
        },
        convertMinutesToHours(seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            return `${hours}h${minutes}m`;
        },
        getData(type = null) {
            this.table_load = true;
            if(type == 'refresh') this.actu_load = true;
            API.post('getAllClocks', this.period)
                .then((res) => {
                    res.data.data.forEach(element => {
                        element.worktime = this.convertMinutesToHours(element.work_time)
                    });
                    this.presences = res.data.data;
                    initdatable('.tablePresence');
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                .finally(()=>{
                    this.table_load = false;
                    if(type == 'refresh') this.actu_load = false;
                })
        },
        period_filtering(fil) {
            if(fil == 'm') this.period = {};
            if(fil == 'p' && !(this.period.start && this.period.end)) {
                return Swal.fire('Erreur!!!!',"Pour effectuer la recherche sur une période, il est obligatoire de choisir la date de début et la date de fin",'error');
            }
            if(fil == 'p') this.period_filter = fil;
            this.getData();
        },
        beforeEnterBox(el){
            gsap.set(el, {
                xPercent: -50,
                scale: 0.97,
                y: -10,
                opacity: 0
            });
        },
        enterBox(el, done){
            gsap.to(el, {
                scale: 1,
                y: 0,
                opacity: 1,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
        leaveBox(el, done){
            gsap.to(el, {
                scale: 0.95,
                y: -10,
                opacity: 0,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
    }
}

</script>